
    var riot = require('riot')
    
riot.tag2('stars', '<div><span each="{stars}}" class="fa fa-star"></span></div>', '', '', function(opts) {
this.stars = new Array(+opts.count);
});
    
  